function SwatchesConstructor(t, e) {
    var n = this;
    n.productIsValid = t.available && "Title" != t.options, n.product_json = t, n.options_name = "", n.options = "", n.viewDesign = window[e.viewDesign], n.contentParent = e.contentParent, n.enableHistoryState = Boolean(e.enableHistoryState) || !1, n.callback = e.callback || !1, n.texture_obj = e.externalImagesObject || {}, n.colors_obj = e.externalColors || {}, n.color_with_border = e.colorWithBorder || {}, n.productIsValid && $(n.contentParent).length ? n.initSwatches() : n.callExternalVariantHandler(n.callback, t.variants[0], n.getJsonObject())
}

function getAllOptions(t) {
    for (var e = "", n = !0, a = {}, i = 0; i < t.length; i++) e = String(t[i].title).replace(/\/ /g, "/").split("/"), n = Boolean(t[i].available), e[0] && n && (e[1] ? (a[e[0]] = a[e[0]] || {}, e[2] ? (a[e[0]][e[1]] = a[e[0]][e[1]] || {}, a[e[0]][e[1]][e[2]] = !0) : a[e[0]][e[1]] = !0) : a[e[0]] = !0);
    return a
}

function getCurrentVariantById(t, e) {
    for (var n = 0; n < t.length; n++)
        if (e) {
            if (t[n].id == e) return t[n]
        } else if (t[n].available) return t[n];
    return t[0]
}

function getCurrentVariantByTitle(t, e, n) {
    if (!e) return t[0];
    for (var a = !0, i = 0; i < t.length; i++) {
        var r = "%%" + t[i].title,
            o = !!n || t[i].available;
        if (r.indexOf("%%" + e) > -1 && o && !a) return t[i];
        if (t[i].title === e && o && a) return t[i];
        i == t.length - 1 && e.indexOf("/") > -1 && ((e = e.split("/")).pop(), e = e.length > 1 ? e.join("/") : e, i = 0, a = !1)
    }
    return t[0]
}

function getVariantIdUrl() {
    var t = location.search;
    return t.indexOf("variant=") > -1 && (t = t.match(/variant=\d+/g), t = parseInt(t[0].match(/\d+/g))), t
}

function isEmpty(t) {
    return 0 === Object.keys(t).length
}

function viewButtons(t, e) {
    e = e || {};
    var n = ".wrapper";
    switch (t) {
        case "getFunctionClickHandler":
            return "buttonHandler";
        case "getGroupElementName":
            return n;
        case "getGroupHtml":
          if (e.title == 'Shipping') {
            return '<div class="' + n.replace(/([\.#])/g, "") + '">' + ('<div class="title-options text-uppercase">' + e.title + ":</div><div style='padding-bottom: 5px;'>For more details check <strong class='goto-shipping'>shipping tab</strong> bellow!</div>") + '<ul class="options options-large">' + e.html + "</ul></div>";
          } else {
            return '<div class="' + n.replace(/([\.#])/g, "") + '">' + ('<div class="title-options text-uppercase">' + e.title + ":</div>") + '<ul class="options options-large">' + e.html + "</ul></div>";
          }
        case "getButtonHtml":
            var a = e.value.trim(),
                i = a.toLowerCase(),
                r = e.c_border.indexOf(a) > -1 ? " border" : "";
            i = "," + i + ":", i = e.colors.indexOf(i) > -1 && e.colors.split(i).pop().split(",").shift().trim();
            var o = a in e.texture ? ' style="background:url(' + e.texture[a] + ')"' : "";
            "" == o && i && (o = ' style="background:' + i + ';"');
            var l = "" != o ? '<li><a href="#" class="options-color' + r + '" data-value="' + a + '" title="' + a + '" ' + o + "></a></li>" : '<li><a href="#" data-value="' + a + '" title="' + a + '">' + a + "</a></li>";
            return e.value != e.selected ? l : l.replace(/<li/, '<li class="active"')
    }
}

function viewSelect(t, e) {
    e = e || {};
    var n = ".wrapper";
    switch (t) {
        case "getFunctionClickHandler":
            return "selectHandler";
        case "getGroupElementName":
            return n;
        case "getGroupHtml":
            return '<div class="' + n.replace(/([\.#])/g, "") + '">' + ('<div class="title-options text-uppercase">' + e.title + ":</div>") + '<select class="form-control select-inline">' + e.html + "</select></div>";
        case "getButtonHtml":
            var a = "<option>" + e.value.trim() + "</option>";
            return e.value != e.selected ? a : a.replace(/<option/, "<option selected")
    }
}
SwatchesConstructor.prototype.destroy = function() {
    var t = $(this.contentParent);
    t.find("a").unbind(), t.find("select").unbind(), t.empty()
}, SwatchesConstructor.prototype.initSwatches = function() {
    var t, e = this,
        n = [];
    t = e.getJsonObject().options;
    for (var a = 0; a < t.length; a++) n[a] = Object(t[a]).name;
    e.options_name = n, e.options = getAllOptions(e.getJsonObject().variants);
    var i = e.enableHistoryState && getVariantIdUrl();
    e.createSwatches(i)
}, SwatchesConstructor.prototype.createSwatches = function(t) {
    var e = this,
        n = e.viewDesign;
    if (isEmpty(e.options)) return !1;
    var a = getCurrentVariantById(e.getJsonObject().variants, t),
        i = String(a.title).replace(/\/ /g, "/").split("/");
    e.createOptionsView(e.contentParent, e.options, e.options_name, i), e[n("getFunctionClickHandler")](), e.callExternalVariantHandler(e.callback, a, e.getJsonObject())
}, SwatchesConstructor.prototype.buttonHandler = function() {
    var t = this,
        e = t.viewDesign,
        n = $(t.contentParent),
        a = e("getGroupElementName"),
        i = n.find(a);
    i.find("a").click(function(e) {
        if (e.preventDefault(), $(this).hasClass("active")) return !1;
        i.find("a").unbind(), $(this).closest(a).find(".active").removeClass("active"), $(this).parent().addClass("active");
        var r = "";
        n.find(".active").find("[data-value]").each(function() {
            r += $(this).attr("data-value") + " / "
        }), t.endOfTheClickHandler(r)
    })
}, SwatchesConstructor.prototype.selectHandler = function() {
    var t = this,
        e = t.viewDesign,
        n = $(t.contentParent),
        a = e("getGroupElementName");
    n.find(a).find("select").change(function() {
        var e = "";
        n.find("select option:selected").each(function() {
            e += $(this).text() + " / "
        }), t.endOfTheClickHandler(e)
    })
}, SwatchesConstructor.prototype.endOfTheClickHandler = function(t) {
    var e = this;
    t = t.substring(0, t.length - 3);
    var n = getCurrentVariantByTitle(e.getJsonObject().variants, t);
    e.enableHistoryState && history.pushState(null, null, location.pathname + "?variant=" + n.id), e.createSwatches(n.id)
}, SwatchesConstructor.prototype.createOptionsView = function(t, e, n, a) {
    var i = this,
        r = i.viewDesign,
        o = $(t).empty(),
        l = i.texture_obj,
        s = i.colors_obj,
        c = i.color_with_border,
        d = "",
        u = "",
        f = "",
        p = "getButtonHtml";
    $.each(e, function(t) {
        if (t == a[0] && "object" == typeof e[t] && "Default Title" != t) {
            var i = e[t];
            $.each(i, function(t) {
                t == a[1] && "object" == typeof i[t] && $.each(i[t], function(t) {
                    f += r(p, {
                        value: t,
                        selected: a[2],
                        title: n[2],
                        texture: l,
                        colors: s,
                        c_border: c
                    })
                }), u += r(p, {
                    value: t,
                    selected: a[1],
                    title: n[1],
                    texture: l,
                    colors: s,
                    c_border: c
                })
            })
        }
        "Default Title" != t && (d += r(p, {
            value: t,
            selected: a[0],
            title: n[0],
            texture: l,
            colors: s,
            c_border: c
        }))
    });
    for (var h = [n[0], n[1], n[2]], v = [d, u, f], m = 0; m < v.length; m++) "" != v[m] && o.append(r("getGroupHtml", {
        title: h[m],
        html: v[m]
    }))
}, SwatchesConstructor.prototype.getJsonObject = function() {
    return this.product_json
}, SwatchesConstructor.prototype.callExternalVariantHandler = function(t, e, n) {
    t && "function" == typeof t && t(e, n)
};
var _custom_loader = $(".custom-loader"),
    modal_qv_parent = $("#ModalquickView"),
    modal_qv_open = !1,
    modal_qv_content = modal_qv_parent.find(".modal-content");
modal_qv_parent.length && modal_qv_parent.on("show.bs.modal", function(t) {
    modal_qv_open = !0, _custom_loader.show(), modal_qv_content.hide();
    var e = $(t.relatedTarget).filter(":first"),
        n = e.attr("data-value"),
        a = e.closest(".product").find(".description").html(),
        i = window.configureQuickView;
    "function" == typeof i && i(n, a)
}).on("hidden.bs.modal", function() {
    modal_qv_open = !1;
    var t = window.destroyQuickView;
    "function" == typeof t && t()
});
var quick_view_loader = {
        btn: !1,
        wait: function(t) {
            if (!modal_qv_open) return !1;
            this.btn = t, t.html(wait_text)
        },
        error: function() {
            if (!modal_qv_open) return !1;
            this.btn.addClass("quickview-error").html(errorhtml_text), this.default_text("quickview-error")
        },
        added: function() {
            if (!modal_qv_open) return !1;
            this.btn.addClass("quickview-added").html(addedhtml_text), this.default_text("quickview-added")
        },
        default_text: function(t) {
            setTimeout(function() {
                quick_view_loader.btn.removeClass(t).html(addtocart_text)
            }, 1e3)
        }
    },
    quickview_swatches = !1;

function configureQuickView(t, e) {
    var n = t.split("/").pop();

    function a(n, a) {
        var i = modal_qv_parent,
            r = i.find(".product-info"),
            o = i.find(".swatches-container");
        swatchVariantHandler(r, n), addToCartHandler.initFormAddToCartButton(n.id, r, o), i.find(".title").html(a.title), i.find(".viewfullinfo") && i.find(".viewfullinfo").attr("href", t), i.find(".qv_vendor") && i.find(".qv_vendor").html(a.vendor);
        var l = i.find(".qv_type");
        l.length && ("" == a.type ? l.parent().hide() : l.html(a.type).parent().show());
        var s = i.find(".product-main-image"),
            c = n.featured_image ? n.featured_image.src : a.featured_image;
        s.children().length ? s.children().first().attr("src", c) : $('<img src="' + c + '" alt="Quick View Image">').appendTo(s);
        var d = i.find(".description").empty();
        d.length && d.html(e)
    }
    Shopify.getProduct(n, function(t) {
        var e = $(".quickview-swatches-container").length && $(".quickview-swatches-container").attr("data-swatches-design");
        quickview_swatches = new SwatchesConstructor(t, {
            contentParent: ".quickview-swatches-container",
            viewDesign: e = "true" == e ? "viewSelect" : "viewButtons",
            enableHistoryState: !1,
            callback: a,
            externalImagesObject: texture_obj,
            externalColors: colors_value,
            colorWithBorder: color_with_border
        }), t = null, _custom_loader.hide(), modal_qv_content.fadeIn()
    })
}

function destroyQuickView() {
    quickview_swatches && quickview_swatches.destroy(), quickview_swatches = !1;
    var t = modal_qv_parent;
    t.find(".product-main-image").empty(), t.find(".description").empty(), t.find(".swatches-container").empty(), t.find(".title").empty()
}

function swatchVariantHandler(t, e) {
    var n = t,
        a = n.find(".price"),
        i = n.find(".add-info"),
        r = i.length && i.find(".sku"),
        o = i.length && i.find(".availability"),
        l = n.find(".input-counter").find("input"),
        s = n.find(".btn-addtocart"),
        c = n.find(".barcode"),
        d = n.find(".qty-label"),
        u = (n.find(".input-counter"), Shopify.formatMoney(e.price, money_format)),
        f = Shopify.formatMoney(e.compare_at_price, money_format);
    e.price < e.compare_at_price ? (a.find(">span:first").addClass("new-price").html(u), a.find(">span:last").removeClass("hide").html(f)) : (a.find(">span:first").removeClass("new-price").html(u), a.find(">span:last").addClass("hide")), r.length && (r.children().last().html(e.sku), "" == e.sku ? r.addClass("hide") : r.removeClass("hide")), c.length && (c.html(e.barcode), "" == e.barcode ? c.parent().addClass("hide") : c.parent().removeClass("hide"));
    var p = e.inventory_management,
        h = e.inventory_policy,
        v = e.inventory_quantity;
    if (o.length && (Boolean(e.available) ? (o.find(".sold_out").addClass("hide"), null == p || "continue" == h ? (v = 9999, o.find(".stock_quantity, .in_stock").addClass("hide"), o.find(".many_in_stock").removeClass("hide")) : (o.find(".stock_quantity").removeClass("hide").html(v), o.find(".in_stock").removeClass("hide"), o.find(".many_in_stock").addClass("hide")), l.val(1).attr("size", v)) : (o.find(".stock_quantity, .in_stock, .many_in_stock").addClass("hide"), o.find(".sold_out").removeClass("hide"))), $("body").trigger("refreshCurrency"), 0 == s.length) return !1;
    Boolean(e.available) ? (d.closest(".wrapper").show(), s.html(addtocart_text).removeClass("disable")) : (d.closest(".wrapper").hide(), s.html(unavailable_text).addClass("disable"))
}